import { CurrentAppConfig } from 'op-pages/RO/Careplan/AppConfig';

export const MESSAGE_ERROR = `This message could not be sent. If you require further information, please email ${CurrentAppConfig.SupportEmail}`;

// Keys for local storage
export const DEPARTMENTS = 'departments';
export const SMS_TYPES = 'smsTypes';
export const STATUSES = 'statuses';
